import {useEffect} from 'react';

/**
 * Points the page at the search app's manifest while it's mounted, so the
 * browser offers to install it (the install icon in Chrome's address bar).
 * It's added here rather than in index.html so only `/search`, behind
 * `ask_relaunch`, is installable; the rest of the app stays a plain site.
 */
export const useSearchAppManifest = () => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = '/search-app.json';
    document.head.appendChild(link);
    return () => link.remove();
  }, []);
};
